import styled from 'styled-components'

import Financials from '../Financials/Financials'
import { JobFinancialsData } from '../Items/JobCosting/jobCostingModel'

export type Props = {
  data?: JobFinancialsData
}
export default function JobFinancialsSection({ data }: Props) {

  const renderFilters = () => {
    return <div />
  }

  return <Wrapper>
    <Financials data={data} renderFilters={renderFilters} />
  </Wrapper>
}

const Wrapper = styled.div`

`
